<template>
    <a-modal
        :width="'60%'"
        v-model="editAlarmConfig"
        :title="$t('alarm.alarmConfig')"
        :maskClosable="maskClosable"
        @ok="handleOk">

        <div style="padding:20px;" v-if="alarmConfig">
            <a-card>
                <a-form :form="form">
                    <a-form-item :label="$t('global.alarmType')" v-bind="formItemLayout">
                      <span class="line">{{$t(`alarm.${alarmConfig.name}`)}}</span>
                      <!-- <i class="icon-alarm icon-lg">
                        <zx-icon :type="computedAlarmIcon(alarmConfig.alarmCode)" />
                      </i> -->
                    </a-form-item>

                    <a-form-item :label="$t('alarm.alarmThreshold')" v-bind="formItemLayout">
                        <a-input v-model="alarmConfig.threshold" :addonAfter="alarmConfig.alarmCode == 1 ? '%' : $t('global.second')" v-if="alarmConfig.enabledThreshold && alarmConfig.alarmCode !== 10001 && alarmConfig.alarmCode !== 10002 && alarmConfig.alarmCode !== 10006 && alarmConfig.alarmCode !== 10007 "  v-decorator="['threshold',{ rules: [{ required: true, message: $t('alarm.thresholdRule') }, alarmConfig.alarmCode == 1 ? {validator: isNumberLt100} : {validator: isNumberGt1800}] }]"></a-input>
                        <a-input v-model="alarmConfig.threshold" :addonAfter="$t('global.secondOnce')"  v-else-if="alarmConfig.alarmCode === 10007 "  v-decorator="['threshold',{ rules: [{ required: true, message: $t('alarm.thresholdRule') },  {validator: isNumberGt60}] }]"></a-input>
                        <a-input :addonAfter="$t('global.timesPerMinute')" v-model="alarmConfig.threshold" v-else-if="alarmConfig.enabledThreshold && alarmConfig.alarmCode == 10002"  v-decorator="['threshold',{ rules: [{ required: true, message: $t('alarm.thresholdRule') }, {validator: isNumberLt100}] }]"></a-input>
                        <a-input :addonAfter="$t('global.temperature')" v-model="alarmConfig.threshold" v-else-if="alarmConfig.enabledThreshold && alarmConfig.alarmCode == 10006"  v-decorator="['threshold',{ rules: [{ required: true, message: $t('alarm.thresholdRule') }, {validator: isNumberLt100}] }]"></a-input>
                       
                        <a-select v-else-if="alarmConfig.enabledThreshold && alarmConfig.alarmCode == 10001" v-model="alarmConfig.threshold" @change="test" :defaultValue="test(alarmConfig.threshold)" size="small">
                            <template v-for="(item, index) in enableSelectTimes">
                                <a-select-option :key="index" :value="item.value">{{item.label}}</a-select-option>
                            </template>
                        </a-select>
                        <span v-else>{{$t('global.nonsupport')}}</span>
                    </a-form-item>

                    <a-form-item v-if="alarmConfig.alarmCode == 10002" :label="$t('alarm.alarmSecondThreshold')" v-bind="formItemLayout">
                        <a-input :addonAfter="$t('global.timesPerMinute')" v-model="alarmConfig.secondThreshold"   v-decorator="['secondThreshold',{ rules: [{ required: true, message: $t('alarm.thresholdRule') }, {validator: isNumber100To200}] }]"></a-input>
                    </a-form-item>

                    <a-form-item v-if="alarmConfig.alarmCode == 10006" :label="$t('alarm.alarmSecondThreshold')" v-bind="formItemLayout">
                        <a-input :addonAfter="$t('global.temperature')" v-model="alarmConfig.secondThreshold"   v-decorator="['secondThreshold',{ rules: [{ required: true, message: $t('alarm.thresholdRule') }, {validator: isNumberLt100}] }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="$t('alarm.repeatable')" v-bind="formItemLayout">
                        <a-select v-model="alarmConfig.repeatFlag" size="small">
                            <a-select-option value="true">{{$t('global.yes')}}</a-select-option>
                            <a-select-option value="false">{{$t('global.no')}}</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('global.alarmLevel')" v-bind="formItemLayout">
                        <a-select  v-model="alarmConfig.level" size="small">
                            <a-select-option v-for="item in levels" :key="item.id" >{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('global.alarmStatu')" v-bind="formItemLayout">
                        <a-switch size="small" v-model="alarmConfig.enabled"/>
                    </a-form-item>

                    <a-form-item v-if="alarmConfig.alarmCode == 1 || alarmConfig.alarmCode == 10001" :label="$t('alarm.autoRecovery')" v-bind="formItemLayout">
                      <a-switch size="small" v-model="alarmConfig.autoDispose"/>
                    </a-form-item>

                    <a-form-item :label="$t('alarm.alarmNotice')" v-bind="formItemLayout">
                        <a-checkbox-group v-model="alarmConfig.noticeTypes" size="small">
                            <a-checkbox v-for="item in noticeTypes" :key="item.id" :value="item.id">{{item.name}}</a-checkbox>
                        </a-checkbox-group>
                    </a-form-item>

                    <a-form-item :label="$t('alarm.ringType')" v-bind="formItemLayout">
                        <a-radio-group  buttonStyle="solid" v-model="alarmConfig.ringType" size="small">
                            <a-radio-button v-for="item in ringTypes" :key="item.value" :value="item.value">{{item.text}}</a-radio-button>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item :label="$t('global.alarmDescription')" v-bind="formItemLayout" v-show="false">
                        <a-textarea v-model="alarmConfig.message" v-decorator="['message',{ rules: [{ required: true, message: $t('alarm.descriptionRule') }] }]"/>
                    </a-form-item>
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import moment from 'moment'
    import {isNumberLt100, isNumberGt1800, isNumber100To200, isNumberGt60} from '../../utils/formFunctions'
    // import {computedAlarmIcon} from '../../utils/homeFn'
    export default {
        name: 'ZEditAlarmConfig',
        data() {
            return {
                maskClosable: false,
                editAlarmConfig: false,
                alarmConfig: null,
                form: null,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 4 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    }
                }
            }
        },
        computed: {
          noticeTypes () {
            return [
              {"id":"1","name": this.$t('alarm.sms')},
              {"id":"2","name": this.$t('alarm.email')},
              {id: '3', name: this.$t('alarm.webPage')}
            ]
          },
          levels () {
            return [
              {"id":1,"name": this.$t('global.event')},
              {"id":2,"name": this.$t('global.noramlAlarm')},
              {"id":3,"name": this.$t('global.importantAlarm')},
              {"id":4,"name": this.$t('global.fearfulAlarm')}
            ]
          },
          enableSelectTimes () {
            return [
              {value: 12 * 3600, label: this.$t('alarm.halfDay')},
              {value: 24 * 3600, label: this.$t('alarm.aDay')},
              {value: 48 * 3600, label: this.$t('alarm.twoDays')},
              {value: 72 * 3600, label: this.$t('alarm.threeDays')}
            ]
          },
          ringTypes () {
            return [
              {text: this.$t('alarm.ringOnce'), value: '2'},
              {text: this.$t('alarm.ringNone'), value: '1'},
              {text: this.$t('alarm.ringAlways'), value: '3'},
            ]
          },
        },
        methods:{
            test (seconds) {
                // console.log(moment.duration({seconds}).humanize())
                return moment.duration({seconds}).humanize()
            },
            moment,
            isNumberLt100,
            isNumberGt1800,
            isNumber100To200,
            isNumberGt60,
            // computedAlarmIcon,
            handleOk(){
                this.form.validateFieldsAndScroll((err) => {
                    if(!err){
                        let noticeType = null
                        if(this.alarmConfig.noticeTypes){
                            noticeType = this.alarmConfig.noticeTypes.join(',')
                        }
                        this.alarmConfig.noticeType = noticeType
                        console.log(this.alarmConfig)
                        this.$http.put(config.api.alarm_config_url,this.alarmConfig).then((response) => {
                            if(response.code == 0){
                                this.editAlarmConfig = false
                                this.$notification.success({
                                  message: this.$t('global.commitSuccess')
                                })
                                this.$emit("updateSuccess")
                            } else {
                                // this.editAlarmConfig = false
                                this.$message.error(response.desc)
                                // this.$emit("updateSuccess")
                            }
                        })
                    }
                })
            },
            showModel(alarmConfig){
                // console.log(alarmConfig)
                this.alarmConfig = alarmConfig
                this.alarmConfig.repeatFlag = this.alarmConfig.repeatFlag + ''
                this.alarmConfig.ringType = this.alarmConfig.ringType + ''
                this.editAlarmConfig = true
                this.form = this.$form.createForm(this)
                // let _this = this
                // setTimeout(() => {
                //     _this.form.setFieldsValue({
                //         message: alarmConfig.message
                //     });
                // },200);
                this.$nextTick().then(() => {
                    this.form.setFieldsValue({
                        message: alarmConfig.message,
                        threshold: alarmConfig.threshold,
                    });
                    if (alarmConfig.secondThreshold) {
                      this.form.setFieldsValue({
                        secondThreshold: alarmConfig.secondThreshold
                      })
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
.line {
  // vertical-align: middle;
  line-height: 1.3em;
  color: red;
}
</style>
